"use client";

import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { PORTALS } from ".constants/portals";
import {
  Button,
  ModalContent,
  PortalModal,
  usePortalContext,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC, useEffect } from "react";
import { useCookies } from "react-cookie";

import { LoaderDraw } from "@/components/loader/LoaderDraw";

export const TutorDrawPortal: FC = () => {
  const t = useTranslations("TutorDrawModal");
  const { currentPortal, closePortal } = usePortalContext();
  const [, setCookies] = useCookies([COOKIES.TUTOR_DRAW_IS_READED]);

  useEffect(() => {
    if (currentPortal === PORTALS.TUTOR_DRAW) {
      setCookies(COOKIES.TUTOR_DRAW_IS_READED, 1, {
        maxAge: COOKIES_TIMES.YEAR_1, // примерно год в секундах
      });
    }
  }, [currentPortal, setCookies]);

  return (
    <PortalModal portalId={PORTALS.TUTOR_DRAW} variant="fixed">
      <ModalContent className="gap-6 pt-8">
        <LoaderDraw />

        <p className="text-center text-2xl font-bold text-balance">
          {t("text")}
        </p>

        <Button size="xl" color="primary" wide centerText onClick={closePortal}>
          {t("textButton")}
        </Button>
      </ModalContent>
    </PortalModal>
  );
};
